module.exports = __webpack_public_path__ + "static/media/Venmo.70aa1a23.png";